module.exports = __webpack_public_path__ + "static/media/Yak.b0ff44c7.jpg";